<div class="header">

    <div class="logo logo-white align-items-center justify-content-center logo-container">
        <nz-row>
            <nz-col nzXs="20" nzMd="24">
                <a [routerLink]="['/']">
                    <img class="logo-primary logo-img" src="assets/images/logo/logo_bi_contable_header_bi_contable.svg" alt="">
                </a>
            </nz-col>
        </nz-row>
    </div>
    <div class="nav-wrap">
        <ul class="nav-custom">
            <li class="mobile-toggle">
                <a (click)="toggleExpand(true)">
                        <i nz-icon [nzType]="isExpand? 'close': 'menu'" theme="outline" class="mobile-toggle-icon"></i>
                </a>
            </li>
        </ul>
        <ul class="nav-left">
            <li class="nav-indicators-wrap">
                <app-indicators></app-indicators>
            </li>
        </ul>
        <ul class="nav-right">
            <li *ngIf="userData && userData['companyName']">
                <div nz-col [nzSm]="24" [nzXs]="12">
                    <span class="m-b-0 text-black text">{{ titleCase(userData["companyName"]) }}</span>
                </div>
            </li>
            <li class="nav-right-spacer">
            </li>
            <li>
                <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" [nzPlacement]="'bottomRight'">
                    <span class="p-h-10 pointer" nz-dropdown>
                        <nz-avatar [nzIcon]="'user'" nzSrc="assets/images/avatars/thumb-2.jpg"
                            [ngClass]="{'avatar-no-border': !avatarUrl}"
                            class="header-avatar">
                        </nz-avatar>
                    </span>
                </a>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu class="p-b-15 p-t-20">
                        <li class="p-h-20 p-b-15 m-b-10 border-bottom">
                            <div class="d-flex m-r-50">
                                <nz-avatar [nzIcon]="'user'" nzSrc="assets/images/avatars/thumb-2.jpg"
                                    [ngClass]="{'avatar-no-border': !avatarUrl}"
                                    class="header-avatar">
                                </nz-avatar>
                                <div class="m-l-10">
                                    <p class="m-b-0 text-dark font-weight-semibold">{{ userData['fullName'] }}</p>
                                </div>
                            </div>
                        </li>
                        <li nz-menu-item>
                            <a class="p-v-5 d-flex align-items-center justify-content-between"
                                (click)="showModal('company')">
                                <div>
                                    <span class="m-l-10">Cambiar Empresa</span>
                                </div>
                            </a>
                        </li>

                        <!--<li nz-menu-item>
                            <a class="p-v-5 d-flex align-items-center justify-content-between"
                                [routerLink]="['/settings/upload-image']">
                                <div>
                                    <span class="m-l-10">Cambiar Imagen</span>
                                </div>
                            </a>
                        </li> -->
                        <li nz-menu-item>
                            <a class="p-v-5 d-flex align-items-center justify-content-between"
                                [routerLink]="['/logout']">
                                <div>
                                    <span class="opacity-04 font-size-16" nz-icon nzType="logout" theme="outline">
                                    </span>
                                    <span class="m-l-10">Cerrar Sesión</span>
                                </div>
                            </a>
                        </li>
                    </ul>
                </nz-dropdown-menu>
            </li>
        </ul>
    </div>

</div>

<nz-modal
      [(nzVisible)]="isVisible"
      nzTitle="Selección de empresa"
      [nzContent]="modalContent"
      [nzFooter]="modalFooter"
      nzWidth="60%"
      (nzOnCancel)="hideModal('company')"
    >
        <ng-template #modalContent>
            <div nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="email">Empresa</nz-form-label>
                <div nz-col [nzSm]="12" [nzXs]="24">
                    <nz-input-group>
                        <nz-select
                            class="w-100"
                            [(ngModel)]="selectedCompany"
                            nzShowSearch
                            nzAllowClear
                            nzPlaceHolder="seleccione una empresa">
                                <nz-option *ngFor="let company of companies"
                                    [nzLabel]="company.code ? company.code + ' - ' + company.name : company.name"
                                    [nzValue]="company.id">
                                </nz-option>
                        </nz-select>
                    </nz-input-group>
                </div>
            </div>
        </ng-template>

        <ng-template #modalFooter>
            <div nz-row class="text-center">

                        <div nz-col [nzSm]="12" [nzXs]="24">
                            <button nz-button nzType="primary" (click)="chooseCompany()">Aceptar</button>
                        </div>
                         <div nz-col [nzSm]="12" [nzXs]="24">
                            <button nz-button nzType="default" (click)="hideModal('company')">Cancelar</button>
                        </div>

            </div>
        </ng-template>
</nz-modal>


<nz-modal
      [(nzVisible)]="isVisibleUpdate"
      nzTitle="Actualizar"
      [nzContent]="modalContentUpdate"
      [nzFooter]="modalFooterUpdate"
      nzWidth="500px"
      (nzOnCancel)="hideModal('update')"
    >
        <ng-template #modalContentUpdate>
            <div nz-row>
                <form nz-form>
                    <div nz-row [nzGutter]="24">
                        <nz-form-item *ngIf="isVisibleYear">
                            <nz-form-label [nzSm]="8" [nzXs]="24" nzRequired nzFor="planType">Año</nz-form-label>
                            <nz-form-control [nzSm]="14" [nzXs]="24">
                              <nz-select
                                [(ngModel)]="selectedYear"
                                nzShowSearch
                                nzAllowClear
                                nzPlaceHolder="Seleccione Año"
                                name="years"
                              >
                                <nz-option *ngFor="let data of years"
                                  [nzLabel]="data"
                                  [nzValue]="data">
                                </nz-option>
                              </nz-select>
                              <nz-form-explain *ngIf="errorYear" class="form-explain-error">
                                Seleccione año
                              </nz-form-explain>
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item *ngIf="isVisiblePeriod">
                            <nz-form-label [nzSm]="8" [nzXs]="24" nzRequired nzFor="planType">Período</nz-form-label>
                            <nz-form-control [nzSm]="14" [nzXs]="24">
                              <nz-select
                                [(ngModel)]="selectedPeriod"
                                nzShowSearch
                                nzAllowClear
                                nzPlaceHolder="Seleccione período"
                                name="periodo"
                              >
                                <nz-option *ngFor="let data of periods"
                                  [nzLabel]="data.label"
                                  [nzValue]="data.value">
                                </nz-option>
                              </nz-select>
                              <nz-form-explain *ngIf="errorPeriod" class="form-explain-error">
                                Seleccione período
                              </nz-form-explain>
                            </nz-form-control>
                        </nz-form-item>
                    </div>

                </form>
            </div>
        </ng-template>

        <ng-template #modalFooterUpdate>
            <div nz-row class="text-center">

                        <div nz-col [nzSm]="12" [nzXs]="24">
                            <button nz-button nzType="primary" (click)="updateButton()">Aceptar</button>
                        </div>
                         <div nz-col [nzSm]="12" [nzXs]="24">
                            <button nz-button nzType="default" (click)="hideModal('update')">Cancelar</button>
                        </div>

            </div>
        </ng-template>
</nz-modal>